import { a as r } from "../internals/array-buffer-view-core.js";
import { l as a } from "../internals/length-of-array-like.js";
import { t } from "../internals/to-integer-or-infinity.js";
var e = r.aTypedArray;
(0, r.exportTypedArrayMethod)("at", function (r) {
  var i = e(this),
    o = a(i),
    n = t(r),
    s = n >= 0 ? n : o + n;
  return s < 0 || s >= o ? void 0 : i[s];
});